module.exports = __webpack_public_path__ + "static/media/171CO220.ba5845a9.jpg";